if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        // For multi‑variant products, set the hidden variant input to "empty"
        // and disable the submit button until a valid selection is made.
        if (this.dataset.hasOnlyDefaultVariant !== 'true') {
          this.variantIdInput.disabled = false;
          this.variantIdInput.value = "empty";
          this.submitButton = this.form.querySelector('[type="submit"]');
          if (this.submitButton) {
            this.submitButton.setAttribute('disabled', 'disabled');
          }
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        if (document.querySelector('cart-drawer')) {
          this.submitButton && this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        // Check if a valid variant has been selected.
        if (this.dataset.hasOnlyDefaultVariant !== 'true') {
          const variantValue = this.variantIdInput.value;
          if (!variantValue || variantValue.trim() === '' || variantValue.trim() === 'empty') {
            // No valid variant selected: add error styling.
            const variantSelects = this.form.querySelector('variant-selects');
            if (variantSelects) {
              variantSelects.classList.add('variant-error');
              const firstSelect = variantSelects.querySelector("select");
              if (firstSelect) firstSelect.focus();
            }
            this.handleErrorMessage('Please select all options');
            return; // Prevent submission.
          } else {
            const variantSelects = this.form.querySelector('variant-selects');
            if (variantSelects) variantSelects.classList.remove('variant-error');
            this.handleErrorMessage();
          }
        }
        
        this.submitButton && this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton && this.submitButton.classList.add('loading');
        this.form.querySelector('.loading__spinner').classList.remove('hidden');
        
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText && this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            this.error = false;
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton && this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton && this.submitButton.removeAttribute('aria-disabled');
            this.form.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.form.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton && this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton && this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      
      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}
